var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "field" },
    [
      _c("label", { staticClass: "label" }, [_vm._v("Model")]),
      _c("div", { staticClass: "field has-addons" }, [
        _c("p", { staticClass: "control" }, [
          _c(
            "a",
            {
              staticClass: "button is-primary",
              on: { click: _vm.searchModelPopup },
            },
            [_vm._m(0)]
          ),
        ]),
        _c(
          "p",
          { staticClass: "control is-expanded" },
          [
            _c("bulma-autocomplete", {
              attrs: {
                value: _vm.modelText,
                data: _vm.models,
                field: "name",
                "keep-first": true,
                loading: _vm.searchingModel,
                expanded: true,
                type: _vm.$v.entity.model.required ? "" : "is-danger",
              },
              on: { input: _vm.searchModel, select: _vm.changeModel },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _c("div", [
                        _c("div", { staticClass: "tags is-pulled-right" }, [
                          _c("span", { staticClass: "tag is-info" }, [
                            _vm._v(
                              " " +
                                _vm._s(props.option.cylinders) +
                                " Cylinders "
                            ),
                          ]),
                          _c("span", { staticClass: "tag is-info" }, [
                            _vm._v(" " + _vm._s(props.option.production) + " "),
                          ]),
                        ]),
                      ]),
                      _c("span", [_vm._v(_vm._s(props.option.name))]),
                    ]
                  },
                },
              ]),
            }),
            !_vm.$v.entity.model.required
              ? _c("span", { staticClass: "help is-danger" }, [
                  _vm._v("Model is required"),
                ])
              : _vm._e(),
          ],
          1
        ),
        _c("p", { staticClass: "control" }, [
          _vm.modelId === ""
            ? _c(
                "a",
                {
                  staticClass: "button is-success tooltip",
                  attrs: { "data-tooltip": "Add unscheduled model" },
                  on: { click: _vm.addModel },
                },
                [_vm._m(1)]
              )
            : _vm._e(),
          _vm.modelId !== "" && _vm.entity.model.isUnscheduled
            ? _c(
                "a",
                {
                  staticClass: "button is-primary tooltip",
                  attrs: { "data-tooltip": "Edit unscheduled model" },
                  on: { click: _vm.checkMultipleModelCustomExists },
                },
                [_vm._m(2)]
              )
            : _vm._e(),
          _vm.modelId !== "" && !_vm.entity.model.isUnscheduled
            ? _c(
                "a",
                {
                  staticClass: "button is-success tooltip",
                  attrs: { "data-tooltip": "Create unscheduled model" },
                  on: { click: _vm.copyModel },
                },
                [_vm._m(3)]
              )
            : _vm._e(),
        ]),
      ]),
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column" }, [
          _vm.entity && _vm.entity.model
            ? _c("div", { staticClass: "field" }, [
                _c("p", { staticClass: "tags" }, [
                  _vm.entity.model.cylinders
                    ? _c("span", { staticClass: "tag is-info" }, [
                        _vm._v(
                          _vm._s(_vm.entity.model.cylinders) + " Cylinders"
                        ),
                      ])
                    : _vm._e(),
                  _c("span", { staticClass: "tag is-info" }, [
                    _vm._v(_vm._s(_vm.entity.model.production)),
                  ]),
                  _vm.entity.model.isUnscheduled
                    ? _c("span", { staticClass: "tag is-info" }, [
                        _vm._v("Unscheduled"),
                      ])
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "column is-flex is-justify-content-flex-end" },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.ntarLtarStatus,
                    expression: "ntarLtarStatus",
                  },
                ],
                staticClass: "field",
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "tag is-success animate__animated animate__pulse animate__repeat-3 tooltip is-tooltip-bottom",
                    attrs: {
                      "data-tooltip": `${_vm.ntarLtarStatus} schedule and times found`,
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.ntarLtarStatus) +
                        " Hours On - " +
                        _vm._s(
                          _vm.entity && _vm.entity.model
                            ? _vm.entity.model.scheduleId
                            : ""
                        )
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]),
      _c("car-model-search-modal", {
        attrs: { visible: _vm.showVehicleSearchModal },
        on: {
          ok: _vm.selectModel,
          cancel: function ($event) {
            _vm.showVehicleSearchModal = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-magnify mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-plus mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-pencil mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-pencil mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }